import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ScheduleDayBoundaryQueryCgResponse,
  ScheduleDayBoundaryQueryVariables,
} from '@common/graphql/schema';

export const SCHEDULE_DAY_BOUNDARY_QUERY: TypedDocumentNode<
  ScheduleDayBoundaryQueryCgResponse,
  ScheduleDayBoundaryQueryVariables
> = gql`
  query ScheduleDayBoundary($orgUnitId: ID!) {
    organizationUnit(uuid: $orgUnitId) {
      id
      scheduleDayBoundary
    }
  }
`;
